import {
  Box,
  Button,
  Container,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Logo from "../../imagens/logo-azul";
import Fundo from "../../imagens/fundo-qrpedir-min.png";
import DadosPessoa from "./Components/DadosPessoa";
import DadosEmpresa from "./Components/DadosEmpresa";
import DadosTipoRestaurante from "./Components/DadosTipoRestaurante";
import DadosPlano from "./Components/DadosPlano";
import AuthService from "../../AuthService";
import * as Pixel from "../../utils/FacebookPixelUtil";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";

function CadastroEmpresaCliente() {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [sending, setSending] = useState(false);
  const [usuario, setUsuario] = useState({
    nome: "",
    email: "",
    telefone: "",
  });
  const [empresa, setEmpresa] = useState({
    nome: "",
    cpfCnpj: "",
    moeda: "REAL",
    tipoConta: "TEMPORARIA",
    dataBloqueio: new Date(new Date().setDate(new Date().getDate() + 15)),
  });
  const [tipoEmpresa, setTipoEmpresa] = useState("outro");
  const [endereco, setEndereco] = useState({
    endereco: "",
    numero: "",
    cep: "",
    bairro: "",
    municipio: null,
    estado: null,
    idPais: 1058,
  });
  const [estados, setEstados] = useState([]);
  const [municipios, setMunicipios] = useState([]);
  const [estado, setEstado] = useState(null);
  const [municipio, setMunicipio] = useState(null);
  const [step, setStep] = useState(1);
  const [open, setOpen] = useState(false);
  const [usuarioAdmin, setUsuarioAdmin] = useState(null);

  useEffect(() => {
    handleVerificaUsuarioAdm();
    Pixel.init();
    Pixel.trackPageView();
  }, []);

  const handleVerificaUsuarioAdm = () => {
    let profile = localStorage.getItem("_profile");
    if (profile) {
      setUsuarioAdmin(JSON.parse(profile));
    }
  };

  const handleChangePessoa = (event) => {
    setUsuario({ ...usuario, [event.target.name]: event.target.value });
  };

  const handleChangeEmpresa = (event) => {
    setEmpresa({ ...empresa, [event.target.name]: event.target.value });
  };

  const handleChangeTipoEmpresa = (event) => {
    setTipoEmpresa(event.target.value);
  };

  const handleChangeEndereco = (event) => {
    setEndereco({ ...endereco, [event.target.name]: event.target.value });
  };

  const handleUpdateEndereco = (newEndereco) => {
    setEndereco(newEndereco);
  };

  const handleChangeStep = (direction) => {
    setStep((prev) => (direction === "+" ? prev + 1 : prev - 1));
  };

  const carregarEstados = () => {
    const service = new AuthService();
    service
      .get("/estado/list")
      .then((retorno) => {
        const options = retorno.map((elem) => ({
          value: elem.id,
          label: elem.nome,
        }));
        options.push({ value: null, label: "selecione um estado" });
        setEstados(options);
      })
      .catch((err) => {
        console.error("Falha ao carregar estados", err);
      });
  };

  const carregarMunicipios = (idEstado) => {
    const service = new AuthService();
    service
      .get(`/municipio/listByEstadoId/${idEstado}`)
      .then((retorno) => {
        const options = retorno.map((elem) => ({
          value: elem.id,
          label: elem.nome,
        }));
        options.push({ value: null, label: "selecione um estado" });
        setMunicipios(options);
      })
      .catch((err) => {
        console.error("Falha ao carregar municipios", err);
      });
  };

  const handleChangeEstado = (selectOption) => {
    if (selectOption) {
      setEstado(selectOption);
      setEndereco((prev) => ({ ...prev, estado: { id: selectOption.value } }));
      setMunicipio(null);
      carregarMunicipios(selectOption.value);
    } else {
      setEstado(null);
      setEndereco((prev) => ({ ...prev, estado: null }));
      setMunicipios([]);
      setMunicipio(null);
    }
  };

  const handleChangeMunicipio = (selectOption) => {
    if (selectOption) {
      setMunicipio(selectOption);
      setEndereco((prev) => ({
        ...prev,
        municipio: { id: selectOption.value },
      }));
    } else {
      setMunicipio(null);
      setEndereco((prev) => ({ ...prev, municipio: null }));
    }
  };

  const handleCreateEmpresa = () => {
    const md5 = require("js-md5");
    const userIsAdm = usuarioAdmin?.admin ?? false;

    const empresaCompleta = { ...empresa };
    for (const [key, value] of Object.entries(endereco)) {
      empresaCompleta[key] = value;
    }

    if (userIsAdm) empresaCompleta.tipoConta = "";

    const usuarioPayload = {
      ...usuario,
      empresa: empresaCompleta,
      createOptions: { tipoEmpresa: tipoEmpresa, ativarDelivery: true },
      username: usuario.email,
      password: md5("123"),
    };

    setSending(true);

    const service = new AuthService();
    service
      .post(`/usuario/create?t=${!userIsAdm}`, usuarioPayload)
      .then((resp) => {
        setSending(false);
        if (userIsAdm) {
          navigate(`/ConfigNewUser/${resp.token}`, { replace: true });
        } else {
          setOpen(true);
        }

        Pixel.trackCustom("Cadastro", {
          name: usuario.nome,
          empresa_name: empresaCompleta.nome,
        });
      })
      .catch((err) => {
        setSending(false);
        console.error(err);
        err.response.json().then((elem) => {
          enqueueSnackbar(
            `Infelizmente não conseguimos criar sua empresa. Entre em contato com nosso suporte. Detalhe: ${elem.errorMessage}`,
            { variant: "error" }
          );
        });
      });
  };

  return (
    <Box style={{ height: "90vh", background: `url(${Fundo}) repeat` }} pt={4}>
      <Container maxWidth="sm">
        <Box display="flex" height="auto" justifyContent="center" p={4} mt={4}>
          <Logo
            style={{ width: "15vw", minWidth: "200px", height: "8rem" }}
            alt="logo-qrpedir"
          />
        </Box>

        {step === 1 ? (
          <DadosPessoa
            pessoa={usuario}
            handleChangePessoa={handleChangePessoa}
            handleChangeStep={handleChangeStep}
          />
        ) : step === 2 ? (
          <DadosEmpresa
            empresa={empresa}
            handleChangeEmpresa={handleChangeEmpresa}
            handleChangeStep={handleChangeStep}
          />
        ) : step === 3 ? (
          <DadosTipoRestaurante
            tipoEmpresa={tipoEmpresa}
            handleChangeTipoEmpresa={handleChangeTipoEmpresa}
            handleChangeStep={handleChangeStep}
          />
        ) : step === 4 ? (
          <DadosPlano
            endereco={endereco}
            estados={estados}
            municipios={municipios}
            handleUpdateEndereco={handleUpdateEndereco}
            handleChangeEndereco={handleChangeEndereco}
            carregarEstados={carregarEstados}
            handleCreateEmpresa={handleCreateEmpresa}
            handleChangeStep={handleChangeStep}
            handleChangeEstado={handleChangeEstado}
            handleChangeMunicipio={handleChangeMunicipio}
            estado={estado}
            municipio={municipio}
            sending={sending}
          />
        ) : null}

        <Dialog open={open}>
          <DialogTitle>
            <Typography align="center" variant="h5">
              Enviamos um e-mail para finalizar seu cadastro.
            </Typography>
          </DialogTitle>
          <DialogContent>
            <Box display="flex" justifyContent="center">
              <Button
                variant="contained"
                color="primary"
                onClick={() =>
                  (window.location.href = process.env.REACT_APP_STATION_URL)
                }
              >
                Voltar a página inicial
              </Button>
            </Box>
          </DialogContent>
        </Dialog>
      </Container>
    </Box>
  );
}

export default CadastroEmpresaCliente;
